/**
 * 公共请求 放在此处
 */

import { mpx } from '@didi/es-mpx-creator';
import { GET_APOLLO_CONFIG, GET_NAV_TIME } from '@/api/urls';

/**
 * @method 获取apollo信息
 * @param params
 * @returns {Promise}
 */

export const requestApolloConfig = data => {
   const params = {
    ...data,
    config: 'train_fe_config'
  };
  return mpx.$http.get(GET_APOLLO_CONFIG, { data: params });
};

export const requestNavTime = (data) => {
  return mpx.$http.post(
    GET_NAV_TIME,
    { data }
  )
}